// src/components/common/EmptyState.tsx
import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";

interface EmptyStateProps {
  title: string;
  message: string;
  icon: React.ReactNode; // Change from React.ReactElement<SvgIconComponent>
  action?: {
    label: string;
    onClick: () => void;
  };
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  message,
  icon,
  action,
}) => {
  return (
    <Paper
      sx={{
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          p: 2,
          bgcolor: "action.hover",
          borderRadius: "50%",
          mb: 2,
          color: "text.secondary",
        }}
      >
        {React.cloneElement(icon as React.ReactElement, {
          sx: { fontSize: "large" },
        })}
      </Box>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        {message}
      </Typography>
      {action && (
        <Button variant="contained" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </Paper>
  );
};

export default EmptyState;
